<template>
<tr @dblclick="$router.push({name: 'resourceTypeEdit', params: {id: resourceType.id}})">
    <td>
      <button v-help.mouse="'Editovat typ projektu'" class="asd-btn-edit" @click="$router.push({name: 'resourceTypeEdit', params: {id: resourceType.id}})">
        <i class="fas fa-pencil-alt"></i>
      </button>
    </td>
    <td>
      {{ resourceType.name }}
    </td>
    <td class="properties-names">
      <span v-for="pt in propertyTypes" :key="pt.id"
            v-help.mouse="pt.activeUntil !== null ? 'Tato vlastnost je deaktivována. Reaktivovat ji můžete v editaci vlastností.|Pokud jí jíž v tomto typu projektu nechcete musíte jí ručně odstranit.' : false"
            :class="{'disabled': pt.activeUntil !== null}"
      >
        {{ pt.name }},
      </span>
    </td>
  </tr>
</template>

<script>
import ResourceTypeDataMixin from 'CORE/mixins/resource-type-data'
import _ from 'lodash'
import { czSorter } from 'CORE/utils/sorters'

export default {
    name: 'ResourceTypeRow',
    mixins: [
        ResourceTypeDataMixin,
    ],
    props: {
        resourceTypeId: {
            type: String,
            required: true,
        },
    },
    computed: {
        propertyTypes() {
            let pt = _.get(this.resourceType, 'propertyType', [])
            pt = _.sortWith(pt, (a, b) => czSorter('asc')(...[a, b].map(c => _.get(c, 'name'))))
            return pt
        },
    },
}
</script>
